module.exports = __webpack_public_path__ + "static/media/remake.a3ed3cb1.svg";